export default __webpack_public_path__ + "static/media/Group9216.b803a7a4.svg";